import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import router from '@/router'

const service = axios.create({
  baseURL: String(process.env.VUE_APP_API_BASE || '').replace(/\/+$/, ''),
  timeout: 20000
})

service.interceptors.request.use(config => {
  const token = store.getters.token
  if (token) config.headers.Authorization = 'Bearer ' + token
  return config
})

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res && typeof res === 'object' && 'code' in res) {
      if (res.code === 1) return res
      if (res.code === 401) {
        store.dispatch('user/resetToken')
        router.push('/login')
      }
      const msg = res.msg || '请求失败'
      Message.error(msg)
      const err = new Error(msg)
      err.code = res.code
      err.data = res.data
      return Promise.reject(err)
    }
    return res
  },
  error => {
    Message.error((error && error.message) || '网络异常')
    return Promise.reject(error)
  }
)

export default service
